
import { Vue, Component, VModel, Prop, Watch } from 'vue-property-decorator'
import { Debounce } from 'lodash-decorators'
import { searchUsers } from '@/utils/user'
import UserAvatar from '@/views/Project/Observation/components/userAvatar.vue'

@Component({
    inheritAttrs: false,
    components: { UserAvatar },
})
export default class UserAutocomplete extends Vue {
    @VModel() user!: null | Record<string, any>
    @Prop({ default: true }) isEnabled!: boolean

    searchTerm = ''
    loading = false
    offset = 0
    limit = 10
    items: Array<any> = []
    infiniteId = crypto['randomUUID']()
    userChanged = false
    usersLoaded = false

    @Watch('searchTerm')
    initLoading() {
        if (this.searchTerm?.length > 1) this.loading = true
    }

    @Debounce(600)
    @Watch('searchTerm')
    async initSearch() {
        if (this.userChanged) {
            this.userChanged = false
            this.loading = false
            return
        }
        this.loading = true
        if (this.searchTerm?.length > 1) {
            this.usersLoaded = false
            this.offset = 0
            this.items = []
            this.infiniteId = crypto['randomUUID']()
            await this.search()
        } else {
            this.setInitValues()
        }

        this.loading = false
    }

    async onUserChange(event) {
        this.userChanged = true
        this.$emit('change', event)
    }

    async search($state = null as any) {
        try {
            this.loading = true

            const filters = {
                'filter[kind]': 'normal',
                'filter[searchTerm]': this.searchTerm,
                ...(this.isEnabled && { 'filter[isEnabled]': this.isEnabled }),
                'page[offset]': this.offset,
                'page[limit]': this.limit,
            }

            const newItems = await searchUsers(filters)

            this.offset += this.limit

            // Prevent infinit loading if all the result are loaded
            if (newItems.length < this.limit) {
                this.usersLoaded = true
            }

            if ($state) {
                if (newItems.length == this.limit) {
                    $state.loaded()
                } else {
                    $state.complete()
                }
            }

            this.items = [...this.items, ...newItems]
        } finally {
            this.loading = false
        }
    }

    setInitValues() {
        if (this.user) {
            this.items = [this.user]
        } else {
            this.items = []
        }
    }

    mounted() {
        this.setInitValues()
        this.userChanged = true
    }
}
